import React, {Component} from 'react'

import LogoImageUrl from '../../../images/stock_color_transparent.png'

class Logo extends Component {

    render() {
        return(
            <img src={LogoImageUrl} alt="Amazon Stock Portal" className="amazon-portal-logo" width={138} height={35}/>
        )
    }
}

export default Logo
